<template>
  <div>
    <div id="cont">
      <input
        type="range"
        :min="min"
        :max="max"
        v-model="value"
        class="slider"
        @input="updateValue($event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleSlider',
  props: {
    min: { default: 0 },
    max: { default: 100 },
    value: { default: 100 }
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>
#cont {
  box-sizing: border-box;
  display: grid;
  align-items: center;
  grid-template-columns: 100%;
  width: 100%;
  height: 100%;
}
.slider {
  height: 4%;
  width: 96%;
}
.slider:focus {
  outline: none;
}
.slider::-webkit-slider-thumb {
  width: 1.7%;
  height: 2em;
  border-radius: 999px;
  border-width: 0;
  background: #00524c;
  cursor: pointer;
  -webkit-appearance: none;
}
[type='range'] {
  height: 1.5em;
  background: transparent;
}
[type='range'],
[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
}
[type='range']::-webkit-slider-runnable-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 96%;
  height: 0.75em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-moz-range-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 96%;
  height: 0.25em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-ms-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 100%;
  height: 0.25em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-webkit-slider-thumb {
  margin-top: -1.6em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 3.2em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-moz-range-thumb {
  box-sizing: border-box;
  border: none;
  width: 0.5em;
  height: 1.2em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-ms-thumb {
  margin-top: 0;
  box-sizing: border-box;
  border: none;
  width: 0.5em;
  height: 1.2em;
  border-radius: 999px;
  background: #00524c;
}
</style>
